//#region src/variants/variants_illustration.js
var variants_illustration_default = { default: { props: { name: { initialValue: "nothing-to-see-here" } } } };
//#endregion
export { variants_illustration_default as default };

//# sourceMappingURL=variants_illustration.js.map